type Messages = {
  errorMessage: string;
  successMessage: string;
};

const NOTIFICATION_MESSAGES: Messages = {
  successMessage: 'Saved',
  errorMessage:
    'Oops, something went wrong. Please try saving your changes again.'
};

export default NOTIFICATION_MESSAGES;
